export enum StatsElementSimpleGridBlock {
  Root = 'StatsElementSimpleGrid',
}
